import { useSelector } from "react-redux";
import type { AuthenticationToken } from "src/authentication/objects/AuthenticationToken";

export function useAuthenticationToken(): AuthenticationToken {
  return useSelector((state) => state.authentication.authenticationToken!);
}
